
// CORE

// MUI

// DATA
import { useSelector } from 'react-redux';
import { getAccountsById } from 'data/accounts/selectors';

// CUSTOM

import * as QC from './core';

function useQCurrency() {

  const accountsById = useSelector(getAccountsById);

  const getObjectSharedCurrency = (...args) => QC.getObjectSharedCurrency(...args);
  const getAccountsSharedCurrency = (...args) => QC.getAccountsSharedCurrency(...args, accountsById);
  const getSharedCurrency = (...args) => QC.getSharedCurrency(...args, accountsById);
  const getAccountIdsCurrency = (...args) => QC.getAccountIdsCurrency(...args, accountsById);
  const getTxnCurrency = (...args) => this.getAccountIdsCurrency(...args);
  const formatAmount = (...args) => QC.formatAmount(...args);
  const formatTxnAmount = (...args) => QC.formatTxnAmount(...args);


  return {
    getObjectSharedCurrency,
    getAccountsSharedCurrency,
    getSharedCurrency,
    getAccountIdsCurrency,
    getTxnCurrency,
    formatAmount,
    formatTxnAmount,
  };
}

export default useQCurrency;
